import AcceptedMaterials from "@/views/permits/RecyclingFacility/AcceptedMaterials.vue";
import DailyOperations from "@/views/permits/RecyclingFacility/DailyOperations.vue";
import OpsLhw from "@/views/permits/RecyclingFacility/LiquidHazardousWaste.vue";
import OpsViolations from "@/views/permits/RecyclingFacility/Violations.vue";

export default {
    AcceptedMaterials,
    DailyOperations,
    OpsLhw,
    OpsViolations
}